import { render, staticRenderFns } from "./pinpaiinfo.vue?vue&type=template&id=3e6d29ee&scoped=true"
import script from "./pinpaiinfo.vue?vue&type=script&lang=js"
export * from "./pinpaiinfo.vue?vue&type=script&lang=js"
import style0 from "./pinpaiinfo.vue?vue&type=style&index=0&id=3e6d29ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6d29ee",
  null
  
)

export default component.exports